<template>
    <div id="app" class="iEKYSP">
        <div id="header-page">
            <Header/>
        </div>

        <div id="content-page" :class="{'content-home': isHomePage}">
            <router-view :key="$route.fullPath"/>
            <not-found-page :title="notFoundPage.title"
                            :content="notFoundPage.content"
                            v-if="notFoundPage.show">
            </not-found-page>
            <not-found-schedule-page :data="notFoundSchedulePage.data"
                            v-if="notFoundSchedulePage.show">
            </not-found-schedule-page>
        </div>

        <div id="footer-page">
            <animate-car v-if="!isHomePage"></animate-car>
        </div>

        <div id="plugin-available">
            <modal-auth></modal-auth>
            <modal-reject-confirm></modal-reject-confirm>
            <modal-notify></modal-notify>
            <loading :active.sync="visible"
                     :color="'#f9af00'"
                     :is-full-page="fullPage">
            </loading>
        </div>
    </div>
</template>
<script>
    import { Header, AnimateCar, NotFoundPage, NotFoundSchedulePage } from "./shared/components";
    import {AUTH_REQUEST} from "../store/actions/Auth";
    import {MixinHelper, eventBus, EVENTS} from "./shared/services";
    import Loading from 'vue-loading-overlay';

    export default {
        components: {NotFoundSchedulePage, NotFoundPage, AnimateCar, Header, Loading},
        mixins: [MixinHelper],
        data() {
            return {
                isHomePage: false,
                loader: null,
                fullPage: true,
                visible: false,
                notFoundPage: {
                    show: false,
                    title: 'Không tìm thấy',
                    content: 'Không tìm thấy nội dung yêu cầu'
                },
                notFoundSchedulePage: {
                    show: false,
                    data: null
                }
            }
        },
        created() {
            eventBus.$on(EVENTS.show_loading, this.showLoader);
            eventBus.$on(EVENTS.hide_loading, this.hideLoader);
            eventBus.$on(EVENTS.unauthorized_error, this.handleUnauthorizedError);
            eventBus.$on(EVENTS.common_error, this.handleCommonError);
            eventBus.$on(EVENTS.server_error, this.handleServerError);
            eventBus.$on(EVENTS.not_found, this.handleNotFound);
            eventBus.$on(EVENTS.not_found_schedule, this.handleNotFoundSchedule);
            eventBus.$on(EVENTS.off_not_found_page, this.handleOffNotFoundPage);
            eventBus.$on(EVENTS.off_not_found_schedule_page, this.handleOffNotFoundSchedulePage);
            if (!this.$store.getters.userData && this.$store.getters.isAuthenticated) {
                this.$store.dispatch(AUTH_REQUEST);
            }

        },
        methods: {
            showLoader() {
                this.visible = true;
            },
            hideLoader() {
                this.visible = false;
            },
            handleUnauthorizedError() {
                this.$modalAuth.show();
            },
            handleCommonError(message) {
                this.$modalNotify.show({
                    content: message
                });
            },
            handleServerError(message) {
                this.$modalNotify.show({
                    content: message
                });
            },
            handleNotFound(notFoundObj) {
                if (notFoundObj) {
                    this.notFoundPage.title = this.getProp(notFoundObj, 'title', '');
                    this.notFoundPage.content = this.getProp(notFoundObj, 'content', '');
                }
                this.notFoundPage.show = true;
            },
            handleNotFoundSchedule(data) {
                if (data) {
                    this.notFoundSchedulePage.data = data;
                }
                this.notFoundSchedulePage.show = true;
            },
            handleOffNotFoundPage() {
                this.notFoundPage.show = false;
            },
            handleOffNotFoundSchedulePage() {
                this.notFoundSchedulePage.show = false;
            }
        },
        watch: {
            '$route': {
                handler(to) {
                    this.isHomePage = to.name === 'home';
                    document.title = this.getProp(to, 'meta.title', 'Hoang Cong');
                },
                immediate: true
            }
        },
        beforeDestroy() {
            eventBus.$off(EVENTS.show_loading);
            eventBus.$off(EVENTS.hide_loading);
            eventBus.$off(EVENTS.unauthorized_error);
            eventBus.$off(EVENTS.common_error);
            eventBus.$off(EVENTS.server_error);
            eventBus.$off(EVENTS.not_found);
            eventBus.$off(EVENTS.not_found_schedule);
            eventBus.$off(EVENTS.off_not_found_page);
            eventBus.$off(EVENTS.off_not_found_schedule_page);
        }
    }
</script>
<style>
    #app {
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-size: 14px;
        line-height: 1.42857143;
        color: #333;
        background-color: #fff;
    }
    a:hover {
        text-decoration: none;
    }
    .iEKYSP {
        position: relative;
    }
    #content-page {
        min-height: calc(100vh - 40px);;
        padding-bottom: 100px;
    }
    #footer-page {
        position: absolute;
        width: 100%;
    }
    .content-home {
        padding-bottom: 0 !important;
        min-height: 0 !important;
    }

    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
</style>
